import React, { useState } from 'react';
import { useAuthentication } from '../context/AuthenticationProvider';
import styled from 'styled-components';
import { useGiftees } from '../context/GifteesProvider';
import {
  getRandomNamedColor,
  NamedColorsHEX,
  ScreenSizesPx,
} from '../util/styles';
import { Name } from '../util/types';
import { Link } from 'react-router-dom';
import gift from '../assets/gift.svg';
import { useShoppingCart } from '../context/ShoppingCartProvider';
import { Giftee } from '../types/Giftee';

const ScHeader = styled.header`
  background-color: ${NamedColorsHEX.LightSeaTurquoise};
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 10px;

  @media screen and (min-width: ${ScreenSizesPx.small}px) {
    padding-bottom: 20px;
  }

  h4 {
    margin: 5px 0;
    @media screen and (max-width: ${ScreenSizesPx.small}px) {
      font-size: 1.2rem;
    }
  }
`;

const ScToolbar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const ScUserIcons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  user-select: none;
`;

const ScIcon = styled.div<{ bgColor: string }>`
  background-color: ${(props) => props.bgColor};
  border-radius: 20px;
  height: 40px;
  width: 40px;
`;

const ScUserIcon = styled(ScIcon)`
  line-height: 40px;
  margin-right: -5px;
  opacity: 0.75;
  text-align: center;
`;

const ScCartIcon = styled(ScIcon)`
  position: relative;

  span {
    background-color: ${NamedColorsHEX.PantoneCoolGray1C};
    border-radius: 7px;
    bottom: 0px;
    font-size: 10px;
    left: 1px;
    line-height: 13px;
    padding: 0 4px;
    position: absolute;
  }
`;

const ScMenu = styled.ul<{ show: boolean }>`
  background-color: ${NamedColorsHEX.LightSeaGreen};
  bottom: -82px;
  display: ${(props) => (props.show ? 'block' : 'none')};
  left: 0;
  margin: 0;
  padding: 0;
  position: absolute;
  width: 100%;
  z-index: 100;

  li {
    border: 0px solid white;
    border-bottom-width: 2px;
    font-weight: 600;
    line-height: 80px;
    list-style-type: none;
    padding-left: 10px;
    user-select: none;

    a,
    span {
      padding: 10px;
    }
  }
`;

export const Header = () => {
  const { user } = useAuthentication();
  const { giftees } = useGiftees();
  const { shoppingCart } = useShoppingCart();
  const [shouldShowMenu, setShouldShowMenu] = useState<boolean>(false);

  if (!user) return null;

  return (
    <ScHeader>
      <ScToolbar>
        <ScUserIcons onClick={() => setShouldShowMenu(!shouldShowMenu)}>
          {user.names.map((name: Name, i) => (
            <ScUserIcon
              key={i}
              className="babys-bold-text"
              bgColor={getRandomNamedColor([
                NamedColorsHEX.PantoneCanoliCream,
                NamedColorsHEX.PantoneCoconutMilk,
              ])}
            >
              {name.name
                .split(' ')
                .splice(0, 2)
                .map((l) => l.substr(0, 1))
                .join('')
                .toUpperCase()}
            </ScUserIcon>
          ))}
        </ScUserIcons>
        <Link to="/carrinho">
          <ScCartIcon bgColor="transparent">
            <img src={gift} alt="Cesto de Presentes" />
            {Object.keys(shoppingCart.items).length > 0 && (
              <span>{Object.keys(shoppingCart.items).length}</span>
            )}
          </ScCartIcon>
        </Link>
      </ScToolbar>
      <Link to="/inicio">
        <h4>Lista de presentes para {Giftee.joinGiftees(giftees, 'e')}.</h4>
      </Link>
      <ScMenu show={shouldShowMenu}>
        <li>
          <Link
            onClick={() => setShouldShowMenu(!shouldShowMenu)}
            to="/meus-presentes"
          >
            Meus Presentes
          </Link>
        </li>
      </ScMenu>
    </ScHeader>
  );
};
